import React from 'react'

export default function EditBottomComponent({cancelButton,saveButton}) {
    return (
       <div style={{marginBottom:5}} className="mt-4" className="text-left">
          <div className="col-lg-12">
                                        <div className="form-group mb-0">
                                          <button style={{ marginRight: 10 }} data-dismiss="modal" type="submit" id="tests" defaultValue="Post Comment" className="btn btn-danger" name="submit"
                                            onClick={cancelButton}
            >Cancel</button>

                     <button style={{ marginRight: 10 }} data-dismiss="modal" type="submit" id="tests" defaultValue="Post Comment" className="submit btn btn-primary" name="submit"
                                            onClick={saveButton}
            >Save</button>
                                        </div>
                                      </div>
      </div>
    )
}

